import { COUNTRIES, COUNTRIES_INFO } from '@app/dashboard/constants/countries';
import { getFromLocalStorage } from './manageLocalStorage';
import { LOCAL_STORAGE_KEYS } from '../constants/local-storage-keys';
import type { TCountry } from '../types/outerLayout/common';
import { getCountryFromDomain } from './getCountryFromDomain';

export const getCountryCurrency = (
  isLive: boolean,
  currencies: Record<'live' | 'test', string[]>
) => {
  const currentMode = isLive ? "live" : "test";
  const country = getFromLocalStorage(LOCAL_STORAGE_KEYS.COUNTRY);
  const countryCurrency = COUNTRIES_INFO[country]?.currency;

  const currency = currencies?.[currentMode]?.includes(countryCurrency)
    ? countryCurrency
    : currencies?.[currentMode][0];

  return currency;
};

export const isForeignCountry = () => {
  const FOREIGN_COUNTRIES = Object.values(COUNTRIES).map((country) => country !== COUNTRIES.EGY && country);
  const country = getCountryFromDomain();

  return FOREIGN_COUNTRIES.includes(country);
};

export const iso3ToIso2 = (country: TCountry, upperCase?: boolean) => {
  const iso2 = COUNTRIES_INFO[country].country_code_iso2;

  return upperCase ? iso2 : iso2.toLowerCase();
};